module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Title/images/calendar-icon.3fe0a5a2.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Title/images/calendar-icon.png
// module id = 2755
// module chunks = 11